// FBSERVICES brand & content constants
export const BRAND = {
  name: "FBSERVICES",
  tagline: "Nettoyage & Espaces Verts",
  city: "Bouc-Bel-Air",
  phone: "07 67 26 81 72",
  phoneHref: "tel:+33767268172",
  email: "fb.pro13@hotmail.com",
  emailHref: "mailto:fb.pro13@hotmail.com",
  address: "",
  hours: "Lun – Sam : 8h00 – 18h00",
};

export const NETTOYAGE_SERVICES = [
  {
    key: "copropriete",
    title: "Nettoyage de copropriété",
    desc: "Entretien régulier des parties communes : halls, ascenseurs, locaux poubelles. Adapté aux syndics et gestionnaires.",
    icon: "Building2",
  },
  {
    key: "bureau",
    title: "Nettoyage de bureaux",
    desc: "Prestations sur-mesure pour entreprises, commerces et professions libérales. Horaires flexibles.",
    icon: "Briefcase",
  },
  {
    key: "cage-escalier",
    title: "Cage d'escalier",
    desc: "Lavage, dépoussiérage et désinfection des escaliers, paliers et rampes. Résultat impeccable.",
    icon: "ArrowUpDown",
  },
  {
    key: "fin-chantier",
    title: "Fin de chantier",
    desc: "Remise en état après travaux : dépose des protections, dépoussiérage, lavage des sols et vitres.",
    icon: "HardHat",
  },
];

export const ESPACES_VERTS_SERVICES = [
  {
    key: "taille-haie",
    title: "Taille de haie & arbustes",
    desc: "Taille de précision pour des haies nettes et des arbustes en pleine forme, toute l'année.",
    icon: "Scissors",
  },
  {
    key: "debroussaillage",
    title: "Débroussaillage & tonte",
    desc: "Débroussaillage réglementaire (OLD), tonte de pelouse régulière et entretien des espaces verts.",
    icon: "Sprout",
  },
  {
    key: "enlevement",
    title: "Enlèvement des végétaux",
    desc: "Évacuation et valorisation de vos déchets verts, en déchetterie agréée.",
    icon: "Truck",
  },
  {
    key: "plantation",
    title: "Plantation & aménagement",
    desc: "Plantation d'arbustes, fleurs et création de massifs adaptés au climat provençal.",
    icon: "Flower2",
  },
];

export const GALLERY = [
  {
    url: "/photos/p1.jpg",
    alt: "Jardin de villa entretenu — Bouc-Bel-Air",
    tag: "Espaces verts",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    url: "/photos/c2.jpg",
    alt: "Hall de copropriété — sol nettoyé",
    tag: "Nettoyage",
  },
  {
    url: "/photos/p4.jpg",
    alt: "Patio et topiaire taillé",
    tag: "Taille",
  },
  {
    url: "/photos/p2.jpg",
    alt: "Haies sculptées devant villa",
    tag: "Espaces verts",
    span: "md:col-span-2",
  },
  {
    url: "/photos/c1.jpg",
    alt: "Sol carrelé après nettoyage",
    tag: "Nettoyage",
  },
  {
    url: "/photos/p3.jpg",
    alt: "Arbustes taillés en boule",
    tag: "Taille",
  },
  {
    url: "/photos/p5.jpg",
    alt: "Réalisation FBSERVICES",
    tag: "Espaces verts",
  },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1760878816701-cbdec5a74ad0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBwcm92ZW5jZSUyMHZpbGxhJTIwZXh0ZXJpb3IlMjBnYXJkZW58ZW58MHx8fHwxNzc4OTExMjIwfDA&ixlib=rb-4.1.0&q=85";

export const TESTIMONIALS = [
  {
    quote: "Service irréprochable sur notre copropriété depuis plus d'un an. Équipe ponctuelle et soignée.",
    author: "Kevin D.",
    role: "Syndic, Aix-en-Provence",
  },
  {
    quote: "FBSERVICES s'occupe de notre jardin et c'est un vrai bonheur. Taille nette, conseils avisés.",
    author: "Graziella P.",
    role: "Particulier, Bouc-Bel-Air",
  },
  {
    quote: "Nous leur confions le nettoyage de nos bureaux : sérieux, réactivité et tarif juste.",
    author: "Elisa M.",
    role: "Office Manager, Marseille",
  },
];
